import apiService from './api';

const investmentService = {
  // Récupérer les plans publics (pas de token requis)
  getPublicPlans: () => apiService.get('/investments/plans'),

  // Souscrire à un plan
  invest: (planId, amount) =>
    apiService.post('/investments/invest', { plan_id: planId, amount }),

  // Récupérer les investissements de l'utilisateur
  getUserInvestments: (params = {}) =>
    apiService.get('/investments/my-investments', params),

  // Historique des paiements
  getPayoutHistory: (params = {}) =>
    apiService.get('/investments/payouts/history', params),

  // Annuler un investissement
  cancelInvestment: (investmentId) =>
    apiService.post(`/investments/${investmentId}/cancel`),
};

export default investmentService;
